module.exports = __webpack_public_path__ + "static/media/call-icon-white.d9c2bc09.svg";